/* eslint-disable */
export default {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "picture-quiz",
    items: [
      { id: "q1", question: "天空是什么颜色？", answers: ["蓝色"], image: "https://images.unsplash.com/photo-1531147646552-1eec68116469?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1950%26q%3D80" },
      { id: "q2", question: "篮球是什么颜色？", answers: ["橙色", "橘色"], image: "https://images.unsplash.com/photo-1519861531473-9200262188bf?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1951%26q%3D80" },
      { id: "q3", question: "香蕉是什么颜色？", answers: ["黄色"], image: "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1400%26q%3D80" },
      { id: "q4", question: "玫瑰是什么颜色？", answers: ["红色"], image: "https://images.unsplash.com/photo-1496857239036-1fb137683000?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1950%26q%3D80" },
      { id: "q5", question: "苹果是什么颜色？", answers: ["绿色"], image: "https://images.unsplash.com/photo-1523757478383-0dff16823e84?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1950%26q%3D80" },
      { id: "q6", question: "冰淇淋是什么颜色？", answers: ["粉色"], image: "https://images.unsplash.com/photo-1532678465554-94846274c297?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80" },
      { id: "q7", question: "雪是什么颜色？", answers: ["白色"], image: "https://images.unsplash.com/photo-1486078695445-0497c2f58cfe?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2874&q=80" },
      { id: "q8", question: "巧克力是什么颜色？", answers: ["棕色"], image: "https://images.unsplash.com/photo-1623660053975-cf75a8be0908?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80" },
      { id: "q9", question: "花是什么颜色？", answers: ["紫色"], image: "https://images.unsplash.com/photo-1526509813677-4d4f89aa6f9a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=864&q=80" },
      { id: "q10", question: "鞋子是什么颜色？", answers: ["黑色"], image: "https://images.unsplash.com/photo-1596702876489-9d11e5806161?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" },
    ],
  },
  botId: "nualang.picture-quiz.0.0.2",
  botName: "picture_quiz",
  description: "picture_quiz_desc",
  difficulty: "ALL",
  learnLang: "chinese",
  name: "小雨",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-images?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# 欢迎来到颜色测验
由小雨主持。

你对颜色了解多少？

对小雨说"你好"开始。`,
  voice: "Zhiyu",
  versionQuestion: "你想在这个模板中有多少个问题？",
};
